import { useQuery } from '@tanstack/react-query';
import { reportingApi } from '../api/reportingApi';
import type { PlatformSummaryQuery } from '../types';

export const usePlatformSummary = (query: PlatformSummaryQuery = {}) =>
  useQuery({
    queryKey: ['reporting', 'platform-summary', query],
    queryFn: () => reportingApi.getPlatformSummary(query),
    // The aggregate fans out to four upstream services; don't refetch on focus.
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
